import { makeStyles } from '@material-ui/core';
import React, {useState } from 'react';
import { Document, Page ,pdfjs} from 'react-pdf';
import './styles-view-pdf.css'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const useStyles = makeStyles({
    root: {
        width: '100%',
        height:'100%'
    },
    page:{
    textAlign:"center"
    }
});

export const  ViewPdf = (props) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber] = useState(1);
  const classes = useStyles();

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  } 

  return (
    <div>
      <Document
        className={classes.root}
        file={props.url}
        onLoadSuccess={onDocumentLoadSuccess}
      >
        <Page pageNumber={pageNumber} className="pdf-ancho"/>
      </Document>
      <p className={classes.page}>Página {pageNumber} de {numPages}</p>
    </div>
  );
}
